import { render, staticRenderFns } from "./u-dropdown.vue?vue&type=template&id=01c0c507&scoped=true&"
import script from "./u-dropdown.vue?vue&type=script&lang=js&"
export * from "./u-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./u-dropdown.vue?vue&type=style&index=0&id=01c0c507&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c0c507",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-dropdown/u-dropdown.vue"
export default component.exports